import { autoserializeAs, inheritSerialization } from 'cerialize';
import { PaginatedResponse } from '@uzurv/core';
import { TransitProgramProvider } from './transit-program-provider';

@inheritSerialization(PaginatedResponse)
export class PaginatedTransitProgramProviderResponse extends PaginatedResponse {
  @autoserializeAs(TransitProgramProvider)
  data: Array<TransitProgramProvider>;
}
